import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import { payoutDetailsPath, PayoutsListPath } from "./urls";
import PayoutDetailsComponent from "./views/PayoutsDetails";
import PayoutListComponent from "./views/PayoutsList";

const PayoutsList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <PayoutListComponent params={params} />;
};

const PayoutsDetails: React.FC = () => {
  const { id } = useParams();
  const params = parseQs(location.search.substr(1));

  return <PayoutDetailsComponent id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Payout",
          description: "Payout section"
        })}
      />
      <Routes>
        <Route path={PayoutsListPath} element={<PayoutsList />} />
        <Route path={payoutDetailsPath(":id")} element={<PayoutsDetails />} />
      </Routes>
    </>
  );
};

export default Component;
